/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Toolbar_Numbered_ListInputs */



/**
* | output |
* | --- |
* | "Numbered List" |
*
* @param {Editor_Toolbar_Numbered_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_toolbar_numbered_list = /** @type {((inputs?: Editor_Toolbar_Numbered_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toolbar_Numbered_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nummerierte Liste")
	return /** @type {LocalizedString} */ ("Numbered List")
});